var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3 gpt-text-info quote-carousel",class:_vm.design},[_c('span',{staticClass:"gpt-text-message"},[_vm._v("\n    "+_vm._s(_vm.message)+"\n    "),_c('strong',{staticClass:"quote-text-author"},[_vm._v("~ "+_vm._s(_vm.authorName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }